body {
  margin: 0;
  overflow: hidden;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
    'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.flex-row {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  flex-shrink: 1;
  /* flex-wrap: wrap; */
}

.flex-col {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  /* flex-wrap: wrap; */
}
